import {cardReaderStyles} from "./styles/card-reader-styles";
import {cardGlobalStyles} from "./styles/card-global-styles";
import {getTranslations} from "@/components/tinyMce/plugins/flipcard/i18n";
import {flipcardCardFaceAttr, flipcardCardParamAttr} from "@/components/tinyMce/plugins/flipcard/flipcardConstants";

// load styles for flipcard in reader mode
const loadFlipCardViewModeAssets = (doc: Document = document) => {
  const flipcardStylesId = 'flipcard-reader-styles';
  if (!doc.getElementById(flipcardStylesId)) {
    const style = doc.createElement('style');
    style.id = flipcardStylesId;
    style.textContent = cardGlobalStyles + cardReaderStyles;
    doc.head.appendChild(style);
  }
};

// activate reader mode for flipcards
const toggleFlipCardViewerMode = (htmlSource: string, lang: string, doc: Document = document) => {
  const temp = doc.createElement('div');
  temp.innerHTML = htmlSource;

  const cards = temp.querySelectorAll('.flipcard-container');
  cards.forEach((card: any) => {
    card.classList.add('reader-mode');
    card.querySelector('.flipcard-header')?.remove();

    Array.from(card.attributes).forEach((attr: any) => {
      if (attr.name.startsWith(flipcardCardParamAttr)) {
        const cssVar = attr.name.replace(`${flipcardCardParamAttr}`, `--flipcard`); //ex: data-tmce-plugin-flipcard-param-header-bg → --flipcard-header-bg
        card.style.setProperty(cssVar, attr.value);
      }
    });

    // éviter que les textes sur faces soient éditables en mode lecture
    card.querySelectorAll('.flipcard-text-content').forEach((faceText: HTMLElement) => {
      faceText.setAttribute('contenteditable', 'false');
    });

    const footer = card?.querySelector('.flipcard-footer');
    const flipBtnText = footer?.querySelector('.flipcard-btn-flip-text');
    if (flipBtnText) {
      flipBtnText.textContent = getTranslations(lang).clickToFlip;
    }
  });
  return temp.innerHTML;
}

// attach flipcard flip click events in reader mode
const setViewModeEvents = (doc: Document = document) => {
  const flipButtons = doc.querySelectorAll('.reader-mode .flipcard-btn-flip');

  flipButtons.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const container = btn.closest('.flipcard-container');
      const faces = container?.querySelectorAll('.flipcard-face');
      const currentActive = container?.querySelector('.flipcard-face.active');

      faces?.forEach(face => face.classList.remove('active'));

      const newFace = currentActive?.getAttribute(flipcardCardFaceAttr) === 'front' ? 'back' : 'front';
      container?.querySelector(`.flipcard-${newFace}`)?.classList.add('active');
    });
  });
}

export default {
  loadFlipCardViewModeAssets,
  setViewModeEvents,
  toggleFlipCardViewerMode
}
